import React, { useState } from "react";
import FormModal from "../../aps2/components/Common/FormModal";
import ApsServices from "../../aps2/services";
import toastStore from "../../aps2/stores/ToastStore";
import DateTimePickerV2 from "../../aps2/components/Common/DateTimePickerV2";
import moment from "moment";

function IsoRepopulateDialog(props: { userId: number; onClose: () => void }) {
  const [processing, setProcessing] = useState(false);
  const [dateFrom, setDateFrom] = useState(moment().startOf("year").toDate());
  const [dateTo, setDateTo] = useState(moment().endOf("day").toDate());

  const submit = () => {
    if (!dateFrom || !dateTo) {
      toastStore.showToast("Date From/To is required.", "warning");
      return;
    }
    if (moment(dateFrom).isAfter(dateTo)) {
      toastStore.showToast("Invalid date range.", "warning");
      return;
    }

    setProcessing(true);
    ApsServices.http.isoCommon
      .isoRepopulate({
        userId: props.userId,
        startDate: dateFrom,
        endDate: dateTo,
      })
      .then(() => {
        props.onClose();
        toastStore.showToast("Request Sent.", "success");
      })
      .catch((err) => {
        toastStore.showError("Unable to process request.", err);
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  return (
    <FormModal
      title="ISO Repopulate"
      isOpen={true}
      close={() => {
        props.onClose();
      }}
      submit={() => {
        submit();
      }}
      submitButtonLabel={processing ? "Submitting..." : "Submit"}
      disableSubmit={processing}
      size="md"
    >
      <div className="flex flex-row flex-center gap-10">
        <div>
          <strong>From:</strong>
        </div>
        <DateTimePickerV2
          dateOnly={true}
          onChange={(data) => {
            setDateFrom(data);
          }}
          data={dateFrom}
          disabled={processing}
        />
        <div>
          <strong>To:</strong>
        </div>
        <DateTimePickerV2
          dateOnly={true}
          onChange={(data) => {
            setDateTo(data);
          }}
          data={dateTo}
          disabled={processing}
        />
      </div>
    </FormModal>
  );
}

export default IsoRepopulateDialog;
